import {
  Box,
  Flex,
  Text,
  Input,
  Button,
  FormLabel,
  IconButton,
  InputGroup,
  FormControl,
  FormErrorMessage,
  InputRightElement,
  FormHelperText,
} from '@chakra-ui/react'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { REPOSITORY } from '../../../api/repository/Repository'
import icon from '../../../utils/assets/ilus-nueva-password.svg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons'
import { faKey, faCheck, faWarning } from '@fortawesome/free-solid-svg-icons'
import { useLoadingContext } from '../../../utils/hooks/Context/LoadingContext'

const KEY = 'two'

export function StepTwo({ onNextStepFinal, step }) {
  const { handleOpen: handleOpenLoading, handleClose: handleCLoseLoading } =
    useLoadingContext()

  const [showPassword, setShowPassword] = useState({
    password: false,
    rpassword: false,
  })

  const handlerUpdatePassword = (values) => {
    handleOpenLoading(true)
    REPOSITORY.wsEmpresa.password
      .cambioContrasenaEmpresa_PrimerLogin({
        sClaveNueva: values.password,
        sClaveNuevaConfirm: values.rpassword,
      })
      .then(() => {
        onNextStepFinal(KEY, values, true)
      })
      .catch(() => {
        onNextStepFinal(KEY, values, false)
      })
      .finally(() => {
        handleCLoseLoading(false)
      })
  }

  const formik = useFormik({
    initialValues: {
      password: step.password,
      rpassword: step.rpassword,
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .required('Ingresa un contraseña')
        .min(8, 'Tu contraseña debe ser mayor o igual a 8 carácteres.')
        .matches(
          /^(?![a-zA-Z\p\d\p{P}\p{S}]+$).*/gm,
          "Incluir por lo menos 1 letra y 1 número y un símbolo ( ~`! @#$%^&*()_-+={[}]|:;'' '<,>.?/ ) .",
        ),
      rpassword: Yup.string()
        .required('Ingresa un contraseña')
        .oneOf(
          [Yup.ref('password'), null],
          'Las contraseñas no coinciden, verifica e intenta nuevamente.',
        ),
    }),
    onSubmit: (values) => {
      handlerUpdatePassword(values)
    },
  })

  const validateErrorsForm = () => {
    const keys = Object.keys(formik.errors)
    return keys.some((key) => formik.touched[key] === true)
  }

  const validateSuccessInput = (key) => {
    return (
      formik.touched[key] &&
      formik.errors[key] === undefined &&
      formik.values[key] !== ''
    )
  }

  const handlerChangeShowPassword = (key) => {
    setShowPassword((old) => ({
      ...old,
      [key]: !old[key],
    }))
  }

  const validateFilledForm = () => {
    return (
      String(formik.values.password).trim() !== '' &&
      String(formik.values.rpassword).trim() !== ''
    )
  }

  return (
    <Flex
      w="100%"
      justifyContent="center"
      pt={{ base: 0, sm: 0, md: 10 }}
      px={{ base: 0, sm: 0, md: 50 }}
    >
      <Box width={{ base: '100%', sm: '100%', md: 550 }}>
        <Box mb={10}>
          <img src={icon} alt="password" />
          <br />
          <Text textAlign="start" fontSize="2xl" mb={5} lineHeight={6}>
            Antes de continuar...
          </Text>
          <Text textAlign="start" fontSize="2xl" mb={25} lineHeight={7}>
            Necesitamos que cambies tu contraseña temporal por una creada por
            tí.
          </Text>
          <Text textAlign="start" mb={2} fontSize="small">
            Como medida de seguridad para tu primer ingreso, es obligatorio
            cambiar tu contraseña.
          </Text>
          <Text textAlign="start" fontSize="small">
            Asegúrate que tu nueva contraseña contenga al menos 8 carácteres.
            Incluir por lo menos 1 letra y 1 número y un símbolo.
          </Text>
        </Box>
        <form onSubmit={formik.handleSubmit}>
          <FormControl
            mb={3}
            isInvalid={formik.touched.password && formik.errors.password}
          >
            <FormLabel fontWeight={600} fontSize={13} mb={1}>
              Nueva contraseña
            </FormLabel>
            <InputGroup>
              <Input
                id="password"
                borderRadius={3}
                backgroundColor="#FFFFFF"
                placeholder="Ingresa tu nueva contraseña aquí"
                type={showPassword.password ? 'text' : 'password'}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.password}
                borderWidth={0}
                boxShadow={
                  validateSuccessInput('password')
                    ? '0 0 0 1px #09825D'
                    : '0px 1px 2px 0px #37415114'
                }
              />
              <InputRightElement>
                <IconButton
                  borderWidth={0}
                  borderRadius={0}
                  aria-label="Password"
                  backgroundColor={'transparent'}
                  icon={
                    showPassword.password ? (
                      <FontAwesomeIcon
                        size="lg"
                        icon={faEyeSlash}
                        color={'#898989'}
                      />
                    ) : (
                      <FontAwesomeIcon
                        size="lg"
                        icon={faEye}
                        color={'#898989'}
                      />
                    )
                  }
                  onClick={() => handlerChangeShowPassword('password')}
                />
              </InputRightElement>
            </InputGroup>
            <FormErrorMessage>
              <FontAwesomeIcon
                size="sm"
                icon={faWarning}
                color={'#E53E3E'}
                style={{ marginRight: 5 }}
              />
              {formik.errors.password}
            </FormErrorMessage>
            {validateSuccessInput('password') && (
              <>
                <FormHelperText color="#09825D">
                  <FontAwesomeIcon
                    size="sm"
                    icon={faCheck}
                    color={'#09825D'}
                    style={{ marginRight: 5 }}
                  />
                  Ser mayor o igual 8 carácteres.
                </FormHelperText>
                <FormHelperText color="#09825D" marginTop={0}>
                  <FontAwesomeIcon
                    size="sm"
                    icon={faCheck}
                    color={'#09825D'}
                    style={{ marginRight: 5 }}
                  />
                  Incluir por lo menos 1 letra y 1 número y un símbolo.
                </FormHelperText>
              </>
            )}
          </FormControl>
          <FormControl
            mb={3}
            isInvalid={formik.touched.rpassword && formik.errors.rpassword}
          >
            <FormLabel fontWeight={600} fontSize={13} mb={1}>
              Repetir contraseña
            </FormLabel>
            <InputGroup>
              <Input
                id="rpassword"
                borderWidth={0}
                borderRadius={3}
                backgroundColor="#FFFFFF"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                value={formik.values.rpassword}
                placeholder="Repetir tu nueva contraseña aquí"
                type={showPassword.rpassword ? 'text' : 'password'}
                boxShadow={
                  validateSuccessInput('rpassword')
                    ? '0 0 0 1px #09825D'
                    : '0px 1px 2px 0px #37415114'
                }
              />
              <InputRightElement>
                <IconButton
                  borderWidth={0}
                  borderRadius={0}
                  aria-label="Password"
                  backgroundColor={'transparent'}
                  onClick={() => handlerChangeShowPassword('rpassword')}
                  icon={
                    showPassword.rpassword ? (
                      <FontAwesomeIcon
                        size="lg"
                        icon={faEyeSlash}
                        color={'#898989'}
                      />
                    ) : (
                      <FontAwesomeIcon
                        size="lg"
                        icon={faEye}
                        color={'#898989'}
                      />
                    )
                  }
                />
              </InputRightElement>
            </InputGroup>
            <FormErrorMessage>
              <FontAwesomeIcon
                size="sm"
                icon={faWarning}
                color={'#E53E3E'}
                style={{ marginRight: 5 }}
              />
              {formik.errors.rpassword}
            </FormErrorMessage>
          </FormControl>
          <Button
            disabled={validateErrorsForm() || !validateFilledForm()}
            borderRadius={5}
            height={100}
            borderColor="#FE8D1D"
            backgroundColor="#FE8D1D"
            mt={4}
            colorScheme="teal"
            type="submit"
            justifyContent="space-between"
            _hover={{ backgroundColor: '#FE8D1D' }}
          >
            <Text fontWeight={600} fontSize={18} color="#ffffff">
              Cambiar contraseña
            </Text>
            <FontAwesomeIcon size="lg" icon={faKey} />
          </Button>
        </form>
      </Box>
    </Flex>
  )
}

StepTwo.propTypes = {
  onNextStepFinal: PropTypes.func,
  step: PropTypes.shape({
    password: PropTypes.string,
    rpassword: PropTypes.string,
  }),
}
